import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector = ({ className = "" }) => {
    const { language, changeLanguage, availableLanguages } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const languageNames = {
        es: 'ES',
        ca: 'CA',
        en: 'EN'
    };

    const languageFullNames = {
        es: 'Español',
        ca: 'Català',
        en: 'English'
    };

    const handleLanguageSelect = (lang) => {
        changeLanguage(lang);
        setIsOpen(false);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    // Cerrar dropdown cuando se hace click fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div className={`language-selector ${className}`} ref={dropdownRef}>
            <div className="custom-language-select" onClick={toggleDropdown}>
                <span className="language-current">
                    {languageNames[language]}
                </span>
                <span className="language-arrow">
                    <i className={`ph ph-caret-${isOpen ? 'up' : 'down'}`}></i>
                </span>
            </div>

            {isOpen && (
                <div className="language-dropdown">
                    {availableLanguages.map(lang => (
                        <div
                            key={lang}
                            className={`language-option ${language === lang ? 'active' : ''}`}
                            onClick={() => handleLanguageSelect(lang)}
                        >
                            <span className="language-code">{languageNames[lang]}</span>
                            <span className="language-name">{languageFullNames[lang]}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;
